import * as yup from 'yup';

// Constants

import { NAMES_VALIDATION_REGEX } from '../../../config/constants';

export const validationSchema = yup.object().shape({
  cliente: yup.object().shape({
    nombre: yup.string().required('Este campo es requerido').test("nombreTest", "Nombre sin acentos o caracteres especiales", function (value) {
      return NAMES_VALIDATION_REGEX?.test(value);
    }),
    primerApellido: yup.string().required('Este campo es requerido').test("primerApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
      return NAMES_VALIDATION_REGEX?.test(value);
    }),
    segundoApellido: yup.string().test("segundoApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
      return NAMES_VALIDATION_REGEX?.test(value);
    }),
    tipoDocumento: yup.string().required('Este campo es requerido'),
    cedulaRif: yup.string().when("tipoDocumento", {
      is: (val) => val !== 'P' && val !== undefined && val !== '',
      then: yup.string().required('Este campo es requerido').test("cedulaTest", "Número de identificación no puede iniciar con 0.", function (value) {
        return value?.charAt(0) !== '0';
      }),
      otherwise: yup.string(),
    }),
    pasaporte: yup.string().when("tipoDocumento", {
      is: (val) => val === 'P',
      then: yup.string().required('Este campo es requerido').test('pasaporteTest', 'Pasaporte de al menos 5 caracteres', val => val?.length >= 5),
      otherwise: yup.string(),
    }),
  }),
});